<template>
    <div class="myBorrow_wrap">
        <top-component ref="topHeader"></top-component>
        <div class="myBorrowlist_part">
            <h2 style="font-size:18px;line-height:40px;padding-bottom:30px;text-align:center;">我的借阅记录</h2>
            <div class="qiehuan">
                <el-form :inline="true" :model="form" class="demo-form-inline" ref="form" label-width="90px">
                    <el-form-item label="ISBN:" prop="isbn">
                        <el-input size="small" v-model="form.isbn" placeholder="请输入ISBN" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="书名:" prop="bookname">
                        <el-input size="small" v-model="form.bookname" placeholder="请输入书名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="作者:" prop="author">
                        <el-input size="small" v-model="form.author" placeholder="请输入作者" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="借阅时间:" class="timepik">
                        <el-form-item prop="bstartdate" class="timepikbok">
                            <el-date-picker :picker-options="startTime" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="开始时间" clearable v-model="form.bstartdate"></el-date-picker>-
                        </el-form-item>
                        <el-form-item prop="benddate" class="timepikbok">
                            <el-date-picker :picker-options="endTime" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="结束时间" clearable v-model="form.benddate"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="是否归还:" prop="borrowstatus">
                        <el-select size="small" v-model="form.borrowstatus" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in borrowStatus" :key="item.val" :label="item.label" :value="item.val" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否超期:" prop="chaoqi">
                        <el-select size="small" v-model="form.chaoqi" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in overdueStatus" :key="item.val" :label="item.label" :value="item.val" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <div style="text-align:center;padding:20px 0;">
                    <el-button size="small" type="primary" @click="getBorrowBookList">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
            <div class="tablelist_box">
                <div class="borrowTip">如有疑问，请联系图书管理员！</div>
                <div class="tab_header" v-if="tableData.length>0">
                    <span class="head_title" style="width:680px;">书目信息</span>
                    <span class="head_title" style="width:510px;">借阅信息</span>
                </div>       
                <div class="rmdbooklist" style="min-height:430px;">
                    <div class="nodata" v-if="tableData.length == 0">暂无数据！</div>
                    <div class="bookinfo" id="list" v-else v-for="(item, index) in tableData" :key="index">
                        <div class="bookinfo_box">
                            <div class="bookImg"><img :src="item.picpath" /></div>
                            <div class="bookdetail">
                                <p class="bookname">{{ item.bookname }}</p>
                                <p>{{ item.author }}</p>
                                <p>{{ item.publish_name }}</p>
                                <p>{{ item.publish_time }}</p>
                            </div>
                            <div class="price">￥{{ item.price }}</div>
                            <div class="book_address">
                                <div class="address_info">
                                    <p><b>借阅时间：</b>{{ item.borrowtime }}</p>
                                    <p><b>借阅截止时间：</b>{{ item.expirationtime }}</p>
                                    <p v-if="item.fakuanjine"><b>逾期罚款：</b>{{ item.fakuanjine }}/天</p>
                                    <!-- <p><b>收货地址：</b>{{ item.address }}</p> -->
                                </div>
                            </div>
                            <div class="status">
                                <div class="status_wrap">
                                    <span :class="{'red': item.chaoqi=='超期', 'blue': item.borrowstatus==0, 'green': item.borrowstatus==1 }">{{ item.chaoqi == '未超期' ? (item.borrowstatus == '0' ? '借阅中' : '已归还') : item.chaoqi }}</span>
                                    <!-- <el-button type="success" @click="returnBookHandle(item.pkid)" v-if="item.borrowstatus != '1'" size="mini">还书</el-button> -->
                                </div>
                            </div>
                        </div>
                    </div>                     
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.pageNum" :page-size="form.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div> 
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>
<script>
    import TopComponent from '../Components/TopComponentcopy.vue'
    import BottomComponent from '../Components/BottomComponent.vue'
    import { getBorrowList, repayBack } from '@/api/manage.js'
    import popup from "@/common/plugin/dialog/index.js";

    export default {
        name: 'myBorrowRecord',
        data() {
            let vm = this;
            return {
                borrowStatus:[
                    {label:'借阅中', val:'0'},
                    {label:'已归还', val:'1'},
                ],
                overdueStatus:[
                    {label:'未超期', val:'未超期'},
                    {label:'超期', val:'超期'},
                ],
                form: {
                    userId: JSON.parse(localStorage.getItem('user')).gid,
                    isbn: '',
                    bookname: '',
                    author: '',
                    bstartdate: '',
                    benddate: '',
                    borrowstatus:'',
                    chaoqi:'',
                    pageNum: 1,
                    pageSize: 10
                },
                tableData:[],
                total:0,
                startTime: {
                    disabledDate: time => {
                        if (vm.form.benddate) {
                            return (
                                time.getTime() > new Date(vm.form.benddate).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.form.bstartdate) {
                            return (
                                time.getTime() < new Date(vm.form.bstartdate).getTime()
                            );
                        }
                    }
                },
            }
        },
        components:{
            TopComponent, BottomComponent
        },
        created(){
            let vm = this;
        }, 
        mounted(){
            let vm = this;
            vm.getBorrowBookList();
        },       
        methods: {
            //还书
            returnBookHandle(pkid){
                let vm = this;
                vm.$confirm("确定归还这本书吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    repayBack({
                        pkid: pkid
                    }).then(res => {

                    }).catch(err => {

                    });
                }).catch(() => {

                });
            },
            //重置
            reset(){
                let vm = this;
                vm.$refs.form.resetFields();
            },
            //建构列表
            getBorrowBookList(){
                let vm = this,
                    obj = vm.form;
                const loading = this.$loading({
                    target: document.querySelector('#list'),
                    lock: true,
                    text: '数据加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(225, 225, 225, 0.5)'
                });
                getBorrowList(obj).then(res => {
                    if(res.status){
                        vm.tableData = res.data.list;
                        vm.total = res.data.total;
                        loading.close();
                    }
                }).catch(err => {
                    loading.close();
                });
            },
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                let vm = this;
                vm.form.pageSize = val;
                vm.getBorrowBookList();
            },
            handleCurrentChange(val){
                let vm = this;
                console.log(`当前页: ${val}`);
                vm.form.pageNum = val;
                vm.getBorrowBookList();
            },
        }
    }

</script>

<style lang="scss">
    .myBorrowlist_part{
        width: 1200px;
        margin:20px auto;
        background-color: #fff;
        padding:20px;
        .el-input--suffix .el-input__inner{
            padding-right: 0;
        }
        .el-form-item__label{
            padding-right:6px;
        }
        .el-form--inline .el-form-item__content{
            width:270px;
        }
        .el-form--inline .timepik .el-form-item__content{
            width:275px;
        }
        .el-form--inline .timepik .timepikbok{
            margin-right: 0;
        }
        .el-form--inline .timepik .timepikbok .el-form-item__content{
            width:120px;
        }
        .el-select{
            width:100%;
        }
        .el-form-item{
            margin-bottom: 5px;
        }        
        .tab_header{
            display: flex;
            justify-content: flex-start;
            height:28px;
            line-height:28px;
            background-color: #daf3ff;
            border:1px solid #daf3ff;
            padding:3px 10px 3px 0;
            margin-top:10px;
            &::before{
                display: table;
                content: " ";
            }
            >span.head_title{
                display: block;
                font-weight: bold;
                color:#5297d8;
                text-align: center;
            }
        }
        .nodata{
            padding: 30px;
            // font-size:12px;
            text-align:center;
            color:#999;
        }
        .ischecked{
            .bookinfo_box{
                background-color:#fffcec;
            }
        }
        .borrowTip{
            font-size:12px;
            color:#ffa32a;
            text-align: right;
        }
        .rmdbooklist{
            .bookinfo{
                // margin-bottom: 10px;
                .infotop{
                    display: flex;
                    justify-content: space-between;
                    background-color: #eaf8ff;
                    border-top:1px solid #daf3ff;
                    border-left:1px solid #daf3ff;
                    border-left:1px solid #daf3ff;
                    padding:5px 10px;
                    font-size:12px;
                    b{
                        color:#666;
                    }
                }
                .bookinfo_box{
                    display: flex;
                    justify-content: space-between;
                    border-left:1px solid #daf3ff;
                    border-right:1px solid #daf3ff;
                    border-bottom:1px solid #daf3ff;
                    // padding: 10px;
                    .bookImg{
                        display: flex;
                        align-items: center;
                        width: 80px;
                        min-height:105px;
                        margin: 5px;
                        img{
                            width:100%;
                        }
                    }
                    .price{
                        display: flex;
                        align-items: center;
                        font-weight: bold;
                        font-size: 16px;
                        color:#ff2a2a;
                        width:100px;
                    }
                    .status{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width:105px;
                        text-align: center;
                        font-weight: bold;
                        font-size:12px;
                        border-left:1px solid #daf3ff;
                        .status_wrap{
                            >span{
                                display: block;
                                line-height:30px;
                            }
                            >span.green{
                                color:#01a82b;
                            }
                            >span.gray{
                                color:#d3d3d3;
                            }
                            >span.yellow{
                                color:#ffa010;
                            }
                            >span.blue{
                                color:#50bff3;
                            }
                            >span.red{
                                color:#ff2a2a;
                            }
                        }
                    }
                    .bookdetail{
                        width:480px;
                        color:#999;
                        font-size:12px;
                        padding: 15px 10px;
                        .bookname{
                            font-weight: bold;
                            color:#333;
                            font-size:14px;
                            padding-bottom: 8px;
                        }
                    }
                    .book_address{
                        width:400px;
                        padding:10px;
                        border-left:1px solid #daf3ff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .address_info{
                            font-size:12px;
                            // height: 28px;
                            line-height: 24px;
                            p{
                                >b{
                                    color:#999;
                                }
                            }
                        }

                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/myBorrowRecord.vue